import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Typography,
  Avatar,
  TextField,
  Slide,
  Fade,
  Button
} from '@mui/material'
import { useAppSelector } from '../../../../../../hooks/reduxHooks'
import { selectUser } from './../../../../../../redux/slices/UserSlice/UserSlice.selectors'
import { stringAvatar } from '../../../../../../applications/users/utils/stringTo'
import SearchIcon from '@mui/icons-material/Search'
import DesktopDropdown from '../desktopDropdown/DesktopDropdown'
import AvailroomCircle from 'src/assets/images/availroom_circle.svg'
import { selectDesktopState } from 'src/redux'
import DesktopApp from 'src/pages/desktop/components/desktopApp/DesktopApp'
import useAuth from 'src/hooks/useAuth'

const Menu = () => {
  const user = useAppSelector(selectUser)
  const { apps } = useAppSelector(selectDesktopState)
  const { logoutUser } = useAuth()
  const [searchValue, setSearchValue] = useState('')

  const [menuDropdownOpen, setMenuDropdownOpen] = useState(false)
  const dropdownEl = useRef<HTMLDivElement>(null)

  const handleOpenMenuDropdown = (event: React.MouseEvent) => {
    event.preventDefault()
    setMenuDropdownOpen(true)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      event.preventDefault()
      if (!dropdownEl.current!.contains(event.target as Node)) {
        setMenuDropdownOpen(false)
      }
    }
    if (menuDropdownOpen) {
      setTimeout(() => {
        window.addEventListener('click', handleClickOutside)
      }, 0)
    } else {
      window.removeEventListener('click', handleClickOutside)
    }
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [menuDropdownOpen])

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value
    setSearchValue(searchValue)
  }

  const handleOpenApp = () => {
    setMenuDropdownOpen(false)
  }

  return (
    <>
      <Button
        sx={{
          color: 'black',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '.25rem'
        }}
        onClick={handleOpenMenuDropdown}
      >
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center'
          }}
        >
          <img src={AvailroomCircle} />
        </Box>
        <Typography
          component='span'
          sx={{
            marginLeft: '.25rem'
          }}
        >
          Menu
        </Typography>
      </Button>
      <Fade in={menuDropdownOpen}>
        <Box>
          <Slide direction='up' in={menuDropdownOpen}>
            <DesktopDropdown
              ref={dropdownEl}
              sx={{
                width: '600px',
                height: '600px',
                position: 'absolute',
                bottom: '5.5rem',
                left: '1rem',
                padding: '3rem',
                zIndex: 900
              }}
            >
              <Box display='flex' alignItems='center'>
                <Avatar {...stringAvatar('Jesus', 50)} />
                <Box ml='1rem'>
                  <Typography fontWeight='700'>
                    {/* ECPECTING TO BE CHANGED, TRADUCIR */}
                    Hola, {user.name}{' '}
                    {user.name !== user.surname ? user.surname : ''}
                  </Typography>
                  <Typography>{user.userName}</Typography>
                </Box>
                <Button
                  sx={{
                    marginLeft: 'auto'
                  }}
                  onClick={() => {
                    logoutUser()
                  }}
                >
                  Logout
                </Button>
              </Box>
              <Box
                sx={{
                  mt: '2rem'
                }}
              >
                <TextField
                  variant='outlined'
                  placeholder='Search an aplication'
                  onChange={handleSearch}
                  InputProps={{
                    endAdornment: (
                      <SearchIcon
                        fontSize='small'
                        sx={{
                          opacity: '50%'
                        }}
                      />
                    )
                  }}
                  sx={{
                    width: '100%',
                    background: 'white',
                    borderRadius: '10px'
                  }}
                />
              </Box>
              <Box
                sx={{
                  maxHeight: 400,
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gridAutoRows: '1fr',
                  marginTop: '1rem',
                  placeItems: 'center',
                  width: '100%',
                  overflowY: 'auto',
                  gap: '1rem'
                }}
              >
                {apps
                  .filter((app) => {
                    if (searchValue)
                      return (
                        app.name
                          .toLowerCase()
                          .includes(searchValue.toLowerCase()) && app.show
                      )
                    return app.show
                  })
                  .map((app, id) => (
                    <DesktopApp
                      textColor='black'
                      size='small'
                      key={'desktopMenu-' + app.id + id}
                      onOpen={handleOpenApp}
                      {...app}
                    />
                  ))}
              </Box>
            </DesktopDropdown>
          </Slide>
        </Box>
      </Fade>
    </>
  )
}

export default Menu
